import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalProspectFinderCategoryOptionsDocument = gql`
  query SalesPortalProspectFinderCategoryOptions(
    $businessOrganizationId: uuid!
  ) {
    getProspectFinderCategoryOptions(
      business_organization_id: $businessOrganizationId
    ) {
      display_name
      yelp_alias
    }
  }
`;
export function useSalesPortalProspectFinderCategoryOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >(SalesPortalProspectFinderCategoryOptionsDocument, options);
}
export function useSalesPortalProspectFinderCategoryOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >(SalesPortalProspectFinderCategoryOptionsDocument, options);
}
export type SalesPortalProspectFinderCategoryOptionsQueryHookResult =
  ReturnType<typeof useSalesPortalProspectFinderCategoryOptionsQuery>;
export type SalesPortalProspectFinderCategoryOptionsLazyQueryHookResult =
  ReturnType<typeof useSalesPortalProspectFinderCategoryOptionsLazyQuery>;
export type SalesPortalProspectFinderCategoryOptionsQueryResult =
  Apollo.QueryResult<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >;

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderCategoryOptionsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalProspectFinderCategoryOptionsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >(SalesPortalProspectFinderCategoryOptionsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderCategoryOptionsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalProspectFinderCategoryOptionsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalProspectFinderCategoryOptionsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalProspectFinderCategoryOptionsQuery,
    Types.SalesPortalProspectFinderCategoryOptionsQueryVariables
  >(SalesPortalProspectFinderCategoryOptionsDocument, lazyOptions);
}
